import * as yup from "yup";
import { addKeyToFieldsRecursively } from "@/react/schema/schemaFields";
import { userSchema } from "@/react/features/smp/licenses/userSchema";

/**
 * @link https://github.com/8x8/platform_SMP_smpcommon/blob/develop/src/main/java/com/_8x8/smp/common/enums/Status.java
 */
export const licenseStatusMap = {
  PENDING: "Pending",
  ACTIVE: "Active",
  SUSPEND: "Suspended",
  SUSPEND_ADMINISTRATOR: "Suspended by Administrator",
  CLOSED: "Closed",
  END_OF_TRIAL_PERIOD: "End of Trial Period",
  ON_HOLD: "On Hold",
  MAX_MINS_REACHED: "Maximum Minutes Reached",
  NON_E911_ADDRESS_SUSPEND: "Suspended due to Non-Emergency Address",
  NON_E911_AND_CREDIT_CARD_SUSPEND:
    "Suspended due to Non-Emergency Address and Credit Card",
  CREDIT_CARD_HOLD: "Credit Card Hold",
  PENDING_CONFIGURATION: "Pending Configuration",
};

const licensePoolSchema = yup.object({
  licensePoolId: yup.string().required(),
  customerId: yup.string().required(),
  packageId: yup.string().required(),
  description: yup.string(),
  inUse: yup.number(),
  suspended: yup.number(),
  quantity: yup.number(),
  unlimited: yup.boolean(),
  priority: yup.number(),
  serviceCountry: yup.string(),
  status: yup.string(),
  skuId: yup.string(),
  name: yup.string(),
});

const licenseSchema = yup.object({
  licenseId: yup.string().required(),
  customerId: yup.string().required(),
  licensePoolId: yup.string().required(),
  seatUsed: yup.number().integer().required(),
  isSuspended: yup.boolean().nullable(),
  status: yup.string().oneOf(Object.keys(licenseStatusMap)).required(),
  referenceId: yup.string().nullable(),
  priority: yup.number().integer().min(0).max(10),
  lastUpdatedTime: yup.number().required(),
  licensePool: licensePoolSchema,
  serviceAddressId: yup.string().required(),
  serviceAddress: yup.string().required(),
  subscriptions: yup.array(),
  user: userSchema,
});

addKeyToFieldsRecursively(licenseSchema);

export { licensePoolSchema, licenseSchema };
